<template>
  <div
    ref="kt_modal_produto_observacoes"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_produto_observacoes"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/communication/com003.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Observações</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.$emit('cancelarEditarObservacoesProduto', false)"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <textarea
            id="txtObservacaoProduto"
            class="form-control mb-2"
            maxlength="300"
            style="height: 150px"
            v-model="this.observacao"
          />
          <div class="text-end text-muted fs-7">
            {{ this.observacao ? this.observacao.length : "0" }}/300 caracteres
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="this.$emit('cancelarEditarObservacoesProduto', false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            type="button"
            class="btn btn-success svg-icon-white mb-2"
            data-bs-dismiss="modal"
            @click="confirmar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["exibirModalObservacoesProduto", "confirmarObservacoesProduto"],
  props: {
    observacoes: { type: String, required: true },
  },
  methods: {
    async confirmar() {
      this.$emit("confirmarObservacoesProduto", this.observacao);
    },
  },
  async mounted() {
    this.observacao = this.observacoes;
    this.$utils.requestFocus("txtObservacaoProduto");
  },
  data() {
    return {
      observacao: "",
    };
  },
};
</script>

<style></style>
